module.exports = __webpack_public_path__ + "static/media/spin.eff59f96.gif";